//inspiration : https://cartzilla-react.createx.studio/contact
import '../../components/css/Main.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

function Contact() {
  const { t } = useTranslation();
  return (
    <div className="contact-page py-5" style={{ fontFamily: "Prompt, sans-serif", background: '#fff', marginTop: "50px", marginBottom: "-50px" }}>

      <div className="container">
        <div className="row mb-5">
          <div className="col-12">
            <h1 className="display-5 fw-bold mb-2">{t('home.contact.title')}</h1>
            <p className="lead mb-4">{t('home.contact.subtitle')}</p>
          </div>
        </div>
        <div className="row contact-info-row">
          <div className="col-md-3 contact-info-col">
            <div className="d-flex align-items-center mb-2">
              <FaMapMarkerAlt size={22} className="me-2 text-danger" />
              <span className="fw-bold">{t('home.contact.locationLabel')}</span>
            </div>
            <hr className="contact-divider" />
            <div className="contact-detail">
              <div>{t('home.contact.addressLine1')}<br />{t('home.contact.addressLine2')}</div>
              <div>{t('home.contact.addressLine3')}</div>
            </div>
          </div>
          <div className="col-md-3 contact-info-col">
            <div className="d-flex align-items-center mb-2">
              <FaPhoneAlt size={22} className="me-2 text-danger" />
              <span className="fw-bold">{t('home.contact.phoneLabel')}</span>
            </div>
            <hr className="contact-divider" />
            <div className="contact-detail">
              <div>{t('home.contact.phoneOffice')}</div>
              <div>{t('home.contact.phoneMobile')}</div>
            </div>
          </div>
          <div className="col-md-3 contact-info-col">
            <div className="d-flex align-items-center mb-2">
              <FaEnvelope size={22} className="me-2 text-danger" />
              <span className="fw-bold">{t('home.contact.emailLabel')}</span>
            </div>
            <hr className="contact-divider" />
            <div className="contact-detail">
              <div>oaoffice1984@gmail.com</div>
              <div>oaoffice@ornthai.com</div>
            </div>
          </div>
          <div className="col-md-3 contact-info-col">
            <div className="d-flex align-items-center mb-2">
              <FaClock size={22} className="me-2 text-danger" />
              <span className="fw-bold">{t('home.contact.hoursLabel')}</span>
            </div>
            <hr className="contact-divider" />
            <div className="contact-detail" style={{ marginBottom: "10rem" }}>
              <div>{t('home.contact.hoursDays')}</div>
              <div>{t('home.contact.hoursTime')}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid px-0 mt-4">
        <div className="map-responsive">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2987.8303049194446!2d100.58491317828334!3d13.794740826538185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29d23e23da677%3A0x14a7d4d171d5a50c!2z4Liq4Liz4LiZ4Lix4LiB4LiH4Liy4LiZ4Lit4Lij4Lit4LiZ4LiH4LiE4LmM4LiB4Liy4Lij4Lia4Lix4LiN4LiK4Li14LmB4Lil4Liw4Liq4Lit4Lia4Lia4Lix4LiN4LiK4Li1!5e0!3m2!1sth!2sth!4v1753150019956!5m2!1sth!2sth"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          ></iframe>
        </div>
      </div>
      {/* Custom CSS for divider, layout, and map responsiveness */}
      <style>{`
        .contact-page {
          background: #f5f7fa;
        }
        .contact-info-row {
          text-align: left;
        }
        .contact-info-col {
          padding-left: 10px;
          padding-right: 10px;
        }
        .contact-divider {
          margin: 0 0 16px 0;
          border-top: 1.5px solid #d1d5db;
        }
        .contact-detail {
          font-size: 1rem;
          color: #222;
        }
        .map-responsive {
          position: relative;
          width: 100vw;
          left: 50%;
          right: 50%;
          margin-left: -50vw;
          margin-right: -50vw;
          height: 450px;
          overflow: hidden;
        }
        .map-responsive iframe {
          width: 100%;
          height: 100%;
          border: 0;
        }
        @media (max-width: 768px) {
          .contact-info-row {
            text-align: center;
          }
          .map-responsive {
            height: 300px;
          }
        }
      `}</style>
    </div>
  );
}

export default Contact;
